import type { ICampaign } from "../../../../../types/models/campaign.models.types";
import type { IPagination } from "../../../../../types/models/pagination.models.types";
import type { IVendor } from "../../../../../types/models/vendor.modals.types";
import { useGetHttp } from "../../../http.hook";

export interface IVendorCampaign {
  id: string;
  vendor: IVendor;
  campaign: ICampaign;
  postCount: number;
  createdAt: string;
  updatedAt: string;
}

interface IResponse {
  vendorCampaigns: IVendorCampaign[];
  pagination: IPagination;
}

export function useGetAllVendorCampaignsMethodsHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/vendors/:vendorId/campaigns",
  });
}
